import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  isAdminSelector,
  protocolsSelector,
  deviceModelByIdSelector,
  attachmentsByModelIdSelector,
} from '../selectors';
import {
  openModelAddModal,
  updateModel,
  deleteModel,
  createModelAttachment,
  updateModelAttachment,
  deleteModelAttachment,
} from '../actions/entry';
import ModelEditStep from '../components/DeviceModels/ActionsPopup/ModelEditStep';

const mapStateToProps = (state, { id, onClose }) => {
  const isAdmin = isAdminSelector(state);
  const protocols = protocolsSelector(state);
  const model = deviceModelByIdSelector(state, id);

  let attachments = [];
  attachments = attachmentsByModelIdSelector(state, id);

  return {
    attachments,
    defaultValue: model,
    protocols,
    isEditable: isAdmin,
    onClose,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onAdd: openModelAddModal,
      onUpdate: (data) => updateModel(data.id, data),
      onDelete: (data) => deleteModel(data.id),
      onAttachmentCreate: (modelId, data) => createModelAttachment(modelId, data),
      onAttachmentUpdate: (data) => updateModelAttachment(data.id, data),
      onAttachmentDelete: deleteModelAttachment,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelEditStep);
